import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // For navigation on button click
import { toast, ToastContainer } from "react-toastify"; // Import react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the styles for react-toastify

const CallsPage = () => {
  const [selectedCallRange, setSelectedCallRange] = useState(null); // State to store the selected call range
  const navigate = useNavigate(); // Initialize the navigate function

  // Function to handle form submission when the "Continue" button is clicked
  const handleSubmit = async (e) => {
    e.preventDefault();

   
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.id) {
      toast.error("User not found. Please log in again.");
      navigate("/");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/intro-data`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id,
          page: 4,
          data: { monthlyCalls: selectedCallRange },
        }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("Excellent!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log("Call Range saved:", data.introData);
        setTimeout(() => navigate("/ai-agent-page"), 1000);
      } else {
        toast.error(data.error || "Failed to save call range.");
      }
    } catch (error) {
      console.error("Error saving call range:", error);
      toast.error("An error occurred. Please try again.");
    }
  };


  const handleSkip = () => {
    navigate("/ai-agent-page")
  };


  // Array of call ranges
  const callRanges = [
    "<250",
    "250 - 1,000",
    "1,000 - 5,000",
    "5,000 - 20,000",
    "20,000 - 200,000",
    "200,000+",
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      {/* Main Content */}
      <div className="flex flex-col items-center text-center max-w-lg mx-auto w-full">
        {/* Full-Width Heading */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4 w-full">
          Oh, and how many calls do you get?
        </h1>

        {/* Subheading */}
        <p className="text-gray-600 text-base md:text-lg mb-8 w-full">
          How many calls do you get per month?
        </p>

        {/* Radio Button Form */}
        <form onSubmit={handleSubmit} className="w-full">
          {/* Radio Buttons */}
          <div className="bg-white rounded-lg shadow-md p-4">
            {callRanges.map((range, index) => (
              <label
                key={index}
                className="flex items-center justify-between px-4 py-2 border-b border-gray-200 cursor-pointer"
              >
                <span>{range}</span>
                <input
                  type="radio"
                  name="callRange"
                  value={range}
                  checked={selectedCallRange === range}
                  onChange={() => setSelectedCallRange(range)}
                  className="form-radio h-4 w-4 text-blue-600 transition duration-200 ease-in-out"
                />
              </label>
            ))}
          </div>

          {/* Continue Button */}
          <button
            type="submit"
            className="bg-blue-600 text-white font-medium py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors w-full mt-4"
          >
            Continue
          </button>

          <button
              type="button"
              onClick={handleSkip}
              className="bg-gray-200 text-gray-700 font-medium py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-gray-300 transition-colors w-full text-sm sm:text-base"
            >
              Skip
            </button>
        </form>
      </div>

      {/* Pagination Dots */}
      <div className="mt-10 flex space-x-2 w-full justify-center">
        {/* Dot 1 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        {/* Dot 2 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        {/* Dot 3 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        {/* Dot 4 (Highlighted) */}
        <div className="w-3 h-3 bg-gray-900 rounded-full"></div>
        {/* Dot 5 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
      </div>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default CallsPage;